import moment from 'moment';
import Api from '../../services/Api';
import Helpers from '../../js/helpers';
import EventBus from '../../js/event-bus';

const getDefaultState = () => ({
  newProject: {},
  listCropEx: [],
  itemsTexture: ['Otro', 'Arcillosa (60% arcilla, 20% arena)', 'Arcillo arenosa (40% arcilla, 50% arena)'],
  analysis_recient: ['', 'Si', 'No'],
  methodPlantation: ['Trasplante', 'Siembra'],
  stationClimate: [{ id: 'Añadir', source: 'Añadir' }],
  cropMedium: ['Suelo', 'Sustrato'],
  floor: ['', 'Añadir'],
  irrigation: ['SUPERFICIE', 'LOCALIZADO'],
  enabledPopUpTexture: false,
  cont: 0,
  climate: [],
  climateSource: null,
  enabledPopUpFertilizers: false,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    setEnabledPopUpFertilizers(context, value) {
      context.commit('setEnabledPopUpFertilizers', value);
    },
    async createDatabaseFertilizer(context, data) {
      try {
        const xhr = await Api.createDatabaseFertilizer(data);
        const fertilizer = JSON.parse(xhr.response);
        EventBus.$emit('selected-fertilizer', fertilizer);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    resetProjectOpenAir({ commit }) {
      commit('resetProjectOpenAir');
    },
    loadProject(context, value) {
      context.commit('loadProject', value);
    },
    async getProjectWithId(context, idProject) {
      try {
        const xhr = await Api.getProject(idProject);
        const project = JSON.parse(xhr.response);
        context.commit('loadProject', project);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async deleteProjectWithId(context, idProject) {
      try {
        await Api.deleteProject(idProject);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchListCropEx(context, value) {
      try {
        const xhr = await Api.fetchListCrop();
        const listCropEx = [];
        const dataCultives = JSON.parse(xhr.response);
        for (const cultive of dataCultives) {
          if (cultive.type === 'EX') listCropEx.push(cultive);
        }
        context.commit(
          'fetchListCropEx',
          listCropEx.sort((a, b) => ((a.name > b.name) ? 1 : -1)),
        );
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchDatabaseClimate(context, province) {
      try {
        const xhr = await Api.fetchDatabaseClimate(province);
        const climate = JSON.parse(xhr.response);
        context.commit('fetchClimate', climate);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchDatabaseClimateSource(context, idSource) {
      try {
        const xhr = await Api.fetchDatabaseClimateSource(idSource);
        const climate = JSON.parse(xhr.response);
        context.commit('fetchClimateSource', climate);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchDatabaseClimateSourceMeanYearEx(context) {
      try {
        const xhr = await Api.fetchDatabaseClimateSourceMeanYearEx();
        const climate = JSON.parse(xhr.response);
        context.commit('fetchClimateSource', climate);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchDatabaseClimateSiar(context, data) {
      try {
        const xhr = await Api.fetchDatabaseClimateSiar(data);
        const climate = JSON.parse(xhr.response);
        context.commit('fetchClimateSource', climate);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    setClimateId(context, value) {
      context.commit('setClimateId', value);
    },
    setPContributed(context, value) {
      context.commit('setPContributed', value);
    },
    setKContributed(context, value) {
      context.commit('setKContributed', value);
    },
    setFertilizer(context, value) {
      context.commit('setFertilizer', value);
    },
    setApplicationDateManure(context, value) {
      context.commit('setApplicationDateManure', value);
    },
    setVolApplied(context, value) {
      context.commit('setVolApplied', value);
    },
    setInitialOrganicMatter(context, value) {
      context.commit('setInitialOrganicMatter', value);
    },
    setInitialWater(context, value) {
      context.commit('setInitialWater', value);
    },
    setNameProject(context, value) {
      context.commit('setNameProject', value);
    },
    setSizeGreenHouse(context, value) {
      context.commit('setSizeGreenHouse', value);
    },
    setArea(context, value) {
      context.commit('setArea', value);
    },
    setProvince(context, value) {
      context.commit('setProvince', value);
    },
    setStation(context, value) {
      context.commit('setStation', value);
    },
    setStationType(context, value) {
      context.commit('setStationType', value);
    },
    setCrop(context, value) {
      context.commit('setCrop', value);
    },
    setDateTransplanting(context, value) {
      context.commit('setDateTransplanting', value);
    },
    setDateEndCrop(context, value) {
      context.commit('setDateEndCrop', value);
    },
    setDensityPlantation(context, value) {
      context.commit('setDensityPlantation', value);
    },
    setEnabledPopUpTexture(context, value) {
      context.commit('setEnabledPopUpTexture', value);
    },
    setTypeIrrigation(context, value) {
      context.commit('setTypeIrrigation', value);
    },
    setDropperFlow(context, value) {
      context.commit('setDropperFlow', value);
    },
    setDistanceBetweenLines(context, value) {
      context.commit('setDistanceBetweenLines', value);
    },
    setDistanceBetweenDrippers(context, value) {
      context.commit('setDistanceBetweenDrippers', value);
    },
    setIrrigationWater(context, value) {
      context.commit('setIrrigationWater', value);
    },
    setSystemEfficiency(context, value) {
      context.commit('setSystemEfficiency', value);
    },
    setAplicationDate(context, value) {
      context.commit('setAplicationDate', value);
    },
    resetNewProjectOpenAir(context, value) {
      context.commit('resetNewProjectOpenAir', value);
    },
    addElementoInFloor(context, value) {
      context.commit('addElementoInFloor', value);
    },
    setChangeTexture(context, value) {
      context.commit('setChangeTexture', value);
    },
    setInitialNitrogen(context, value) {
      context.commit('setInitialNitrogen', value);
    },
    setManureSelected(context, value) {
      context.commit('setManureSelected', value);
    },
    async createNewProjectOpenAir({ state }) {
      try {
        const manure = Helpers.parseManure(state.newProject.manure);
        if (!state.newProject.name) {
          throw new Error('El campo "Nombre del proyecto" es requerido.');
        }
        // if (state.newProject.area <= 0) {
        //   throw new Error('El campo "Tamaño parcela" es requerido.');
        // }
        if (!state.newProject.province) {
          throw new Error('El campo "Provincia" es requerido.');
        }
        if (!state.newProject.province) {
          throw new Error('El campo "Provincia" es requerido.');
        }
        if (!state.newProject.weather_source && !state.newProject.climate_id) {
          throw new Error('El campo "Estación agroclimática" es requerido.');
        }
        if (!state.newProject.cultive.crop_id) {
          throw new Error('El campo "Cultivo" es requerido.');
        }
        if (!state.newProject.cultive.date_init) {
          throw new Error('El campo "Fecha de siembra" es requerido.');
        }
        if (!state.newProject.cultive.date_end) {
          throw new Error('El campo "Fecha prevista fin de cultivo" es requerido.');
        }

        // if (state.newProject.cultive.density_plantation <= 0) {
        //   throw new Error('El campo "Densidad de plantación" es requerido.');
        // }
        if (!state.newProject.irrigation.typeIrrigation) {
          throw new Error('El campo "Tipo de riego" es requerido.');
        }
        if (state.newProject.irrigation.typeIrrigation === 'SUPERFICIE') {
          if (typeof state.newProject.irrigation.systemEfficiency !== 'number' || state.newProject.irrigation.systemEfficiency <= 0) {
            throw new Error('El campo "Eficiencia del sistema" es requerido.');
          }
          if (typeof state.newProject.irrigation.irrigationWater !== 'number' || state.newProject.irrigation.irrigationWater < 0) {
            throw new Error('El campo "N agua de riego" es requerido.');
          }
        } else {
          if (typeof state.newProject.irrigation.distanceBetweenLines !== 'number' || !state.newProject.irrigation.distanceBetweenLines) {
            throw new Error('El campo "Distancia entre lineas" es requerido.');
          }
          if (typeof state.newProject.irrigation.distanceBetweenDrippers !== 'number' || !state.newProject.irrigation.distanceBetweenDrippers) {
            throw new Error('El campo "Distancia entre goteros" es requerido.');
          }
          if (typeof state.newProject.irrigation.dropperFlow !== 'number' || state.newProject.irrigation.dropperFlow <= 0) {
            throw new Error('El campo "Caudal gotero" es requerido.');
          }
          if (typeof state.newProject.irrigation.systemEfficiency !== 'number' || state.newProject.irrigation.systemEfficiency <= 0) {
            throw new Error('El campo "Eficiencia del sistema" es requerido.');
          }
          if (typeof state.newProject.irrigation.irrigationWater !== 'number' || state.newProject.irrigation.irrigationWater < 0) {
            throw new Error('El campo "N agua de riego" es requerido.');
          }
        }
        if (!state.newProject.ground.texture) {
          throw new Error('El campo "Textura" es requerido.');
        }
        if (state.newProject.ground.depth <= 0) {
          throw new Error('El campo "Profundidad" es requerido.');
        }
        if (state.newProject.ground.initialNitrogen < 0) {
          throw new Error('El campo "Nitrógeno inicial" es requerido.');
        }
        if (state.newProject.ground.initial_organic < 0) {
          throw new Error('El campo "Materia orgánica inicial" es requerido.');
        }
        if (state.newProject.ground.initial_water < 0) {
          throw new Error('El campo "Contenido agua inicial " es requerido.');
        }
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (state.newProject.weather_source_type === 'REAL_TIME' && state.newProject.cultive.date_end >= today) {
          throw new Error('El campo "Fecha prevista fin de cultivo" debe ser una fecha anterior al día de hoy si no se '
              + 'eligen datos climáticos de "año medio"');
        }
        const allDataNewProject = {
          name: state.newProject.name,
          type: 'EX',
          area: state.newProject.area,
          province: state.newProject.province,
          weather_source: state.newProject.weather_source,
          weather_source_type: state.newProject.weather_source_type,
          climate_id: state.newProject.climate_id,
          cultive: {
            crop_id: state.newProject.cultive.crop_id,
            date_init: moment(state.newProject.cultive.date_init).format('YYYY-MM-DD'),
            date_end: moment(state.newProject.cultive.date_end).format('YYYY-MM-DD'),
            crop_type: null,
            density: state.newProject.cultive.density_plantation,
          },
          ground_external: {
            texture_id: state.newProject.ground.texture,
            root_deep: state.newProject.ground.depth,
            initial_nitrogen: state.newProject.ground.initialNitrogen,
            initial_organic: state.newProject.ground.initial_organic,
            initial_water: state.newProject.ground.initial_water,
            P_contributed: state.newProject.ground.P_contributed,
            K_contributed: state.newProject.ground.K_contributed,
            fertilizer: state.newProject.ground.fertilizer,
          },
          ground: null,
          irrigation: {
            irrigation_id: null,
            irrigation_open_air: state.newProject.irrigation.typeIrrigation
              ? state.newProject.irrigation.typeIrrigation.toUpperCase() : null,
            analysis: null,
            ce: null,
            units_ce: null,
            et0_ecuation: null,
            line_distance: state.newProject.irrigation.distanceBetweenLines
              ? state.newProject.irrigation.distanceBetweenLines : null,
            drip_distance: state.newProject.irrigation.distanceBetweenDrippers
              ? state.newProject.irrigation.distanceBetweenDrippers : null,
            caudal: state.newProject.irrigation.dropperFlow
              ? state.newProject.irrigation.dropperFlow : null,
            efficiency: state.newProject.irrigation.systemEfficiency,
            n_water: state.newProject.irrigation.irrigationWater,
          },
          whitewashed: null,
          manure,
        };
        try {
          await Api.createNewProject(allDataNewProject);
        } catch (e) {
          console.error(e);
          return Promise.reject(new Error('¡Upss ha ocurrido un error! Por favor verifique sus datos.'));
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async updateProjectOpenAir({ state }) {
      try {
        const manure = Helpers.parseManure(state.newProject.manure);
        if (!state.newProject.name) {
          throw new Error('El campo "Nombre del proyecto" es requerido.');
        }
        // if (state.newProject.area <= 0) {
        //   throw new Error('El campo "Tamaño parcela" es requerido.');
        // }
        if (!state.newProject.province) {
          throw new Error('El campo "Provincia" es requerido.');
        }
        if (!state.newProject.province) {
          throw new Error('El campo "Provincia" es requerido.');
        }
        if (!state.newProject.weather_source && !state.newProject.climate_id) {
          throw new Error('El campo "Estación agroclimática" es requerido.');
        }
        if (!state.newProject.cultive.crop_id) {
          throw new Error('El campo "Cultivo" es requerido.');
        }
        if (!state.newProject.cultive.date_init) {
          throw new Error('El campo "Fecha de siembra" es requerido.');
        }
        if (!state.newProject.cultive.date_end) {
          throw new Error('El campo "Fecha prevista fin de cultivo" es requerido.');
        }
        // if (state.newProject.cultive.density_plantation <= 0) {
        //   throw new Error('El campo "Densidad de plantación" es requerido.');
        // }
        if (!state.newProject.irrigation.typeIrrigation) {
          throw new Error('El campo "Tipo de riego" es requerido.');
        }
        if (state.newProject.irrigation.typeIrrigation === 'SUPERFICIE') {
          if (typeof state.newProject.irrigation.systemEfficiency !== 'number' || state.newProject.irrigation.systemEfficiency <= 0) {
            throw new Error('El campo "Eficiencia del sistema" es requerido.');
          }
          if (typeof state.newProject.irrigation.irrigationWater !== 'number' || state.newProject.irrigation.irrigationWater < 0) {
            throw new Error('El campo "N agua de riego" es requerido.');
          }
        } else {
          if (typeof state.newProject.irrigation.distanceBetweenLines !== 'number' || !state.newProject.irrigation.distanceBetweenLines) {
            throw new Error('El campo "Distancia entre lineas" es requerido.');
          }
          if (typeof state.newProject.irrigation.distanceBetweenDrippers !== 'number' || !state.newProject.irrigation.distanceBetweenDrippers) {
            throw new Error('El campo "Distancia entre goteros" es requerido.');
          }
          if (typeof state.newProject.irrigation.dropperFlow !== 'number' || state.newProject.irrigation.dropperFlow <= 0) {
            throw new Error('El campo "Caudal gotero" es requerido.');
          }
          if (typeof state.newProject.irrigation.systemEfficiency !== 'number' || state.newProject.irrigation.systemEfficiency <= 0) {
            throw new Error('El campo "Eficiencia del sistema" es requerido.');
          }
          if (typeof state.newProject.irrigation.irrigationWater !== 'number' || state.newProject.irrigation.irrigationWater < 0) {
            throw new Error('El campo "N agua de riego" es requerido.');
          }
        }
        if (!state.newProject.ground.texture) {
          throw new Error('El campo "Textura" es requerido.');
        }
        if (state.newProject.ground.depth <= 0) {
          throw new Error('El campo "Profundidad" es requerido.');
        }
        if (state.newProject.ground.initialNitrogen < 0) {
          throw new Error('El campo "Nitrógeno inicial" es requerido.');
        }
        if (state.newProject.ground.initial_organic < 0) {
          throw new Error('El campo "Materia orgánica inicial" es requerido.');
        }
        if (state.newProject.ground.initial_water < 0) {
          throw new Error('El campo "Contenido agua inicial " es requerido.');
        }
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (state.newProject.weather_source_type === 'REAL_TIME' && state.newProject.cultive.date_end >= today) {
          throw new Error('El campo "Fecha prevista fin de cultivo" debe ser una fecha anterior al día de hoy si no se '
              + 'eligen datos climáticos de "año medio"');
        }
        const allDataNewProject = {
          name: state.newProject.name,
          type: 'EX',
          area: state.newProject.area,
          province: state.newProject.province,
          weather_source: state.newProject.weather_source,
          weather_source_type: state.newProject.weather_source_type,
          climate_id: state.newProject.climate_id,
          cultive: {
            crop_id: state.newProject.cultive.crop_id,
            date_init: moment(state.newProject.cultive.date_init).format('YYYY-MM-DD'),
            date_end: moment(state.newProject.cultive.date_end).format('YYYY-MM-DD'),
            crop_type: null,
            density: state.newProject.cultive.density_plantation,
          },
          ground_external: {
            texture_id: state.newProject.ground.texture,
            root_deep: state.newProject.ground.depth,
            initial_nitrogen: state.newProject.ground.initialNitrogen,
            initial_organic: state.newProject.ground.initial_organic,
            initial_water: state.newProject.ground.initial_water,
            P_contributed: state.newProject.ground.P_contributed,
            K_contributed: state.newProject.ground.K_contributed,
            fertilizer: state.newProject.ground.fertilizer,
          },
          ground: null,
          irrigation: {
            irrigation_id: null,
            irrigation_open_air: state.newProject.irrigation.typeIrrigation
              ? state.newProject.irrigation.typeIrrigation.toUpperCase() : null,
            analysis: null,
            ce: null,
            units_ce: null,
            et0_ecuation: null,
            line_distance: state.newProject.irrigation.distanceBetweenLines
              ? state.newProject.irrigation.distanceBetweenLines : null,
            drip_distance: state.newProject.irrigation.distanceBetweenDrippers
              ? state.newProject.irrigation.distanceBetweenDrippers : null,
            caudal: state.newProject.irrigation.dropperFlow
              ? state.newProject.irrigation.dropperFlow : null,
            efficiency: state.newProject.irrigation.systemEfficiency,
            n_water: state.newProject.irrigation.irrigationWater,
          },
          whitewashed: null,
          manure,
        };
        try {
          await Api.updateProject(allDataNewProject, state.newProject.id);
        } catch (e) {
          console.error(e);
          return Promise.reject(new Error('¡Upss ha ocurrido un error! Por favor verifique sus datos.'));
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async recalculateProject(context, value) {
      try {
        await Api.recalculateProject(value.data, value.id);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
  },
  mutations: {
    setEnabledPopUpFertilizers(state, value) {
      state.enabledPopUpFertilizers = value;
    },
    resetProjectOpenAir(state) {
      Object.assign(state, getDefaultState());
    },
    setNameProject(state, value) {
      if (state.newProject.id && !state.newProject.originalName) {
        state.newProject.originalName = state.newProject.name;
      }
      state.newProject.name = value;
    },
    setArea(state, value) {
      state.newProject.area = value;
    },
    setSizeGreenHouse(state, value) {
      state.newProject.ground.depth = value;
    },
    setProvince(state, value) {
      state.newProject.province = value;
    },
    setStation(state, value) {
      state.newProject.weather_source = value;
    },
    setStationType(state, value) {
      state.newProject.weather_source_type = value;
    },
    setDateTransplanting(state, value) {
      state.newProject.cultive.date_init = value;
    },
    setPassword(state, value) {
      state.newProject.password = value;
    },
    setSurname(state, value) {
      state.newProject.surname = value;
    },
    setDateEndCrop(state, value) {
      state.newProject.cultive.date_end = value;
    },
    setDensityPlantation(state, value) {
      state.newProject.cultive.density_plantation = value;
      state.newProject.cultive.density = value;
    },
    setCrop(state, value) {
      state.newProject.cultive.crop_id = value;
    },
    setEnabledPopUpTexture(state, value) {
      state.enabledPopUpTexture = value;
    },
    setAnalysisPreview(state, value) {
      state.newProject.analysis_recientSelected = value;
    },
    setTypeIrrigation(state, value) {
      state.newProject.irrigation = {
        typeIrrigation: value,
        irrigation_id: '',
        irrigation_name: '',
        dropperFlow: null,
        distanceBetweenLines: null,
        distanceBetweenDrippers: null,
        systemEfficiency: null,
        irrigationWater: null,
      };
    },
    setDropperFlow(state, value) {
      state.newProject.irrigation.dropperFlow = value;
    },
    setDistanceBetweenLines(state, value) {
      state.newProject.irrigation.distanceBetweenLines = value;
    },
    setDistanceBetweenDrippers(state, value) {
      state.newProject.irrigation.distanceBetweenDrippers = value;
    },
    setSystemEfficiency(state, value) {
      state.newProject.irrigation.systemEfficiency = value;
    },
    setIrrigationWater(state, value) {
      state.newProject.irrigation.irrigationWater = value;
    },
    setAplicationDate(state, value) {
      state.newProject.aplicationDate = value;
    },
    setChangeTexture(state, value) {
      state.newProject.ground.texture = value;
    },
    addElementoInFloor(state, value) {
      // TODO: SUPONGO QUE HABRÁ QUE ENVIAR LOS DATOS RELLENADOS EN EL POPUP a back.
      state.floor.push(value.name);
    },
    fetchListCropEx(state, value) {
      state.listCropEx = value;
    },
    setInitialNitrogen(state, value) {
      state.newProject.ground.initialNitrogen = value;
    },
    fetchClimate(state, value) {
      state.climate = value;
    },
    fetchClimateSource(state, value) {
      state.climateSource = value;
    },
    setClimateId(state, value) {
      state.newProject.climate_id = value;
    },
    setPContributed(state, value) {
      state.newProject.ground.P_contributed = value;
    },
    setKContributed(state, value) {
      state.newProject.ground.K_contributed = value;
    },
    setFertilizer(state, value) {
      state.newProject.ground.fertilizer = value;
    },
    setManureSelected(state, value) {
      state.newProject.manure.manure_id = value;
    },
    setApplicationDateManure(state, value) {
      state.newProject.manure.date = value;
    },
    setVolApplied(state, value) {
      state.newProject.manure.volume = value;
    },
    setInitialOrganicMatter(state, value) {
      state.newProject.ground.initial_organic = value;
    },
    setInitialWater(state, value) {
      state.newProject.ground.initial_water = value;
    },
    resetNewProjectOpenAir(state) {
      state.newProject = {
        id: '',
        name: '',
        type: '',
        area: null,
        province: '',
        weather_source: '',
        climate_id: '',
        cultive: {
          crop_id: '',
          crop_name: '',
          date_init: '',
          date_end: '',
          crop_type: '',
          crop_method: '',
          density_plantation: null,
        },
        ground: {
          ground_id: '',
          ground_name: '',
          texture: '',
          depth: null,
          initialNitrogen: null,
          initial_organic: null,
          initial_water: null,
          P_contributed: null,
          K_contributed: null,
        },
        irrigation: {
          typeIrrigation: '',
          irrigation_id: '',
          irrigation_name: '',
          dropperFlow: null,
          distanceBetweenLines: null,
          distanceBetweenDrippers: null,
          systemEfficiency: null,
          irrigationWater: null,
        },
        manure: {
          manure_id: '',
          manure_name: '',
          date: '',
          volumen: null,
        },
      };
    },
    loadProject(state, value) {
      state.newProject = value;
    },
  },
};
